import { render, staticRenderFns } from "./_HexColor.vue?vue&type=template&id=45e4fdc8&"
import script from "./_HexColor.vue?vue&type=script&lang=js&"
export * from "./_HexColor.vue?vue&type=script&lang=js&"
import style0 from "./_HexColor.vue?vue&type=style&index=0&id=45e4fdc8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports